import { useGetBlurStyles } from '@/hooks/useGetBlurStyles';
import { BlurOptions } from '@/types/blur';
import { ElementType } from 'react';

export const Blur = ({
  children,
  options,
  as: Component = 'span',
}: {
  children?: React.ReactNode;
  options?: BlurOptions;
  as?: ElementType;
}) => {
  const styles = useGetBlurStyles(options);

  return <Component style={styles}>{children}</Component>;
};
